import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'
import './styles.css'

function NumericInput({ id, value = 1, disabled, update, remove }) {
  return (
    <div className="numeric-input">
      <button
        type="button"
        className="minus"
        onClick={() => {
          if (!disabled) {
            if (value > 1) {
              update(id, value - 1)
            } else {
              remove(id)
            }
          }
        }}
      >
        -
      </button>
      <div className="number">
        <input
          aria-label="Quantity"
          type="number"
          name="quantity"
          value={value}
          disabled
        />
      </div>
      <button
        type="button"
        className={classnames('plus', { disabled: value > 98 })}
        onClick={() => {
          if (value < 99 && !disabled) {
            update(id, value + 1)
          }
        }}
      >
        +
      </button>
    </div>
  )
}

NumericInput.propTypes = {
  disabled: PropTypes.bool.isRequired,
  update: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  remove: PropTypes.func.isRequired,
  value: PropTypes.number
}

export default NumericInput
